import React from 'react'
import { Advisor, AdvisorProfileProps } from '../../utils/types'
import ProfileStat from './ProfileStat'
import '../../styles/Advisors/AdvisorsShared.scss'
import capitalizeStatesInLocation from '../../utils/capitalizeStatesInLocation'

const getExpertisesList = (expertises?: string[], advisorExpertises?: string): string[] | undefined => {
  let combinedExpertises: string[] = []
  if (expertises && expertises.length > 0) {
    combinedExpertises = expertises
  } else if (advisorExpertises) {
    combinedExpertises = advisorExpertises.split(',').map(e => e.trim())
  }
  combinedExpertises = combinedExpertises.filter(expertise => expertise)
  return combinedExpertises.length > 0 ? combinedExpertises : undefined
}

const buildStats = (advisor: Advisor, expertisesList?: string[]): { label: string, value: React.ReactNode }[] => {
  const stats: { label: string, value: React.ReactNode }[] = []
  if (advisor.format === 'firm' || advisor.format === 'network') {
    if (advisor.founded_in && !advisor.founded_in?.includes('null')) stats.push({ label: 'Founded In', value: advisor.founded_in })
    if (advisor.location) stats.push({ label: 'Location', value: capitalizeStatesInLocation(advisor.location) })
    if (expertisesList && expertisesList.length > 0) {
      stats.push({
        label: 'Areas of Focus',
        value: (<div className="expertises">{expertisesList.map((expertise, index) => (<span key={index}>{expertise}</span>))}</div>)
      })
    }
  }
  if (advisor.format === 'human') {
    if (advisor.experience && !advisor.experience?.includes('null')) stats.push({ label: 'Experience', value: advisor.experience })
    if (advisor.distance !== undefined && advisor.distance !== null) {
      const displayDistance = advisor.distance === '0 miles'
        ? '1 Mile'
        : advisor.distance === '1 miles' ? '1 Mile' : advisor.distance
      stats.push({ label: 'Distance From You', value: displayDistance })
    }
    if (advisor.location) stats.push({ label: 'Location', value: capitalizeStatesInLocation(advisor.location) })
    if (expertisesList && expertisesList.length > 0) {
      stats.push({
        label: 'Areas of Focus',
        value: (<div className="expertises">{expertisesList.map((expertise, index) => (<span key={index}>{expertise}</span>))}</div>)
      })
    }
  }
  return stats
}

const AdvisorProfile = ({ advisor, expertises, children }: AdvisorProfileProps) => {
  const expertisesList = getExpertisesList(expertises, advisor.expertises)
  const stats = buildStats(advisor, expertisesList)
  const { id, match_product_type: matchProductType } = advisor.network

  return (
            <div className="profile listing"
                data-is-cpm-match={matchProductType === 'CPM' ? 'true' : 'false'}
                data-network-id={id}
            >
                <div className="profile_top">
                    <div className="top_left">
                        {advisor.imageUrl && advisor.imageUrl.trim() !== '' && (
                            <img src={advisor.imageUrl} alt={`${advisor.name} logo`} />
                        )}
                        <div className="name_container">
                            <h4 className="advisor_type">{advisor.format === 'human' ? 'Advisor' : `Advisory ${advisor.format}`}</h4>
                            <h3 className="profile_name">{advisor.name}</h3>
                            {advisor.format === 'human' && <h3 className="profile_firm">{advisor.firm}</h3>}
                        </div>
                    </div>
                    <div className="top_right">
                        {stats.map((stat, index) => (stat.value && <ProfileStat key={index} label={stat.label} value={stat.value} />))}
                    </div>
                </div>
                {children}
            </div>
  )
}

export default AdvisorProfile
